/**
 * ハンバーガーメニュー
 */
let hamburger = () => {
  $(function () {
    const $hamburgerBtn = $('#js-hamburger');
    const $nav = $('#js-nav');

    // 要素が無いページでは何もしない
    if (!$hamburgerBtn.length || !$nav.length) return;

    $hamburgerBtn.on('click', function () {
      $hamburgerBtn.toggleClass('is-active');
      $nav.toggleClass('is-active');

      // アクセシビリティ対応
      const isOpen = $hamburgerBtn.hasClass('is-active');
      $hamburgerBtn.attr('aria-expanded', String(isOpen));
      $nav.attr('aria-hidden', String(!isOpen));
    });

    // メニューの外側をクリックした時の処理
    $(document).on('click', function (e) {
      const isClickInside = $(e.target).closest('#js-nav, #js-hamburger').length > 0;

      if (!isClickInside && $nav.hasClass('is-active')) {
        $hamburgerBtn.removeClass('is-active').attr('aria-expanded', 'false');
        $nav.removeClass('is-active').attr('aria-hidden', 'true');
      }
    });
  });
};

/**
 * 初期化
 */
let init = () => {
  hamburger();
};

export default { init, hamburger };
